import React, { useEffect, useState } from 'react';
import LoginRegisterTab from '../../components/Auth/LoginRegisterTab';
import './login-register.css';
import LoginRegisterSidebar from './LoginRegisterSidebar';
import Api from '../../inc/Api';
import Settings from '../../inc/Settings';
import CompanyDomain from './CompanyDomain';
import { useLocation, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import ActionTypes from '../../inc/ActionsTypes';
import Helper from '../../inc/Helper';
import SimpleLoading from '../../components/Loading/SimpleLoading';
import { requestPermission } from '../../services/Firebase/FirebaseServiceFunctions';

const htmlContent2 = `<!doctype html>
<html lang="en">
    <head>
        <meta charset="UTF-8">
        <title>Lynkaz | Oops!</title>
        <link rel="shortcut icon" href="https://dfydac381qi3t.cloudfront.net/static/public/images/favicon.ico">
        <style>
            @import url('https://fonts.googleapis.com/css?family=Overpass:400,600&display=swap'); </style>
        <style>
            body, html {
                font-family: 'Overpass', sans-serif;
                background: #414141;
                color: #fff;
                height: 100%;
                width: 100%;
                margin: 0;
                padding: 0;
            }

            a {
                color: #fff;
            }

            .container {
                display: flex;
                height: 100%;
                width: 100%;
                align-items: center;
                justify-content: center;
            }

            .btn {
                font-size: 11px;
                text-decoration: none;
                position: relative;
                display: inline-block;
                min-width: 10em;
                padding: 1.09091em 2.18182em;
                margin-bottom: 0;
                font-family: Open Sans,Arial;
                font-style: normal;
                font-weight: 600;
                line-height: 1.09091em;
                text-align: center;
                text-transform: uppercase;
                white-space: normal;
                vertical-align: middle;
                cursor: pointer;
                border: 1px solid #e3e3e3;
                -webkit-border-radius: .27273em;
                -moz-border-radius: .27273em;
                -ms-border-radius: .27273em;
                -o-border-radius: .27273em;
                border-radius: .27273em;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
                -webkit-box-shadow: 0 0.166em 0.333em 0 rgba(0,0,0,.2);
                -moz-box-shadow: 0 .166em .333em 0 rgba(0,0,0,.2);
                box-shadow: 0 0.166em 0.333em 0 rgba(0,0,0,.2);
                background-color: #03ba5b;
                border: 1px solid #03ba5b;
            }

            h1 {
                margin-top: 0;
            }
        </style>
    </head>
    <body>
        <div class="container">
            <div class="info-text">
                <div class="bg-circles">
                    <div class="astronaut"></div>
                    <div class="info-text">
                        <h1>
                            Lynkaz,<br/>WE HAVE A PROBLEM...
                        </h1>
                        <h2>the page you're looking for is lost in space</h2>
                        <a class="btn btn--green btn--large mt40" href="${Settings.supportLoginUrl}">RETURN TO DASHBOARD</a>
                    </div>
                </div>
            </div>
        </div>
    </body>
</html>
`

const showCompanyDomain = (extractedText) => {
  if (!extractedText) return true
  const { hostname, href } = window.location
  if (hostname === 'localhost') {
    return href === 'http://localhost:3000/login' || href === 'http://localhost:3000/'
  }
  if (Settings.integrationFrontendHost && hostname === Settings.integrationFrontendHost) return true
  return Settings.companyDomainHosts.some((host) => host && href.includes(host))
}

const Login = (props) => {
  const [loginData,setLoginData]=useState('')
  const [loading,setLoading]=useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const locationPath = window.location.href;
  const parsedUrl = new URL(locationPath);
  const hostnameParts = parsedUrl?.hostname?.split('.');
  const subdomain = hostnameParts[0];
  const extractedText = subdomain ? subdomain : null;

  const onLoginClickHandler = async (e) => {
    e.preventDefault(); 

    const email = document.getElementById('dynamic-login-email')?.value;
    const password = document.getElementById('dynamic-login-password')?.value;

    if(!email) {
      Helper.alert('Please provide email!', 'error');
      return;
    }

    if(!password) {
      Helper.alert('Please provide password!', 'error');
      return;
    }

    const locationPath = window.location.href;
    const parsedUrl = new URL(locationPath);
    const hostnameParts = parsedUrl?.hostname?.split('.');
    const subdomain = hostnameParts[0] ? hostnameParts[0] : null;

    let formData = {
      username: email,
      password: password, 
    };

    let api = Api;
    api.setJsonHeader();
    api.axios().post(Settings.apiUrl + '/auth/token/', formData).then(function({authResponse}){
      if(authResponse){ 
        const defaultDataFormate = 'dd/mm/yyyy'; 
        // set user token to browser
        Helper.setCookie(Settings.userTokenKey, authResponse.access, Settings.userTokenExpireDate);
        Helper.setCookie(Settings.dateFormateKey, defaultDataFormate);
        Helper.setCookie(Settings.tenantSubdomain, subdomain)
        props.setDateFormate(defaultDataFormate);

        // setTimeout(()=>{
        //   navigate('/' + Settings.redirectUrlAfterLogin)
        // }, 200);
        
        // api.axios().get(Settings.apiUrl+'/auth/user/me/',{}).then(function({loginResponse}){
        //   if(loginResponse){
        //     console.log(loginResponse.data, 'data')
        //     props.setUser(loginResponse.data);
        //     props.login(loginResponse.data);
        //   }
        //   setTimeout(()=>{
        //     navigate('/' + Settings.redirectUrlAfterLogin)
        //   }, 200)
        // })
      }
    }).catch((error)=>{
      const errorDiv = document.getElementById('error-message');
      if (errorDiv) {
        errorDiv.textContent = error?.response?.data?.message;
      }
    });
  };

  const getLogInDetails = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const tParam = urlParams.get('t');
      const api = Api;
      api.setUserToken();
      if (tParam && extractedText) { 
        Helper.setCookie(Settings.userTokenKey,tParam,Settings.userTokenExpireDate);
        navigate('/system-integration'); 
        return;
      }

      setLoading(true);

      if (showCompanyDomain(extractedText)) {
        setLoading(false);
        return;
      }
    } catch (error) {
      if (error?.response?.status === 404 && error?.response?.headers['content-type'] === 'application/json') {
        setLoginData(htmlContent2);
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getLogInDetails(); 
  }, [location?.pathname]);

  useEffect(() => {
    const submitButton = document.getElementById('dynamic-login-submit');
  
    const handleClick = (e) => {
      e.preventDefault();  
      onLoginClickHandler(e);
    };
  
    if (submitButton) {
      submitButton.addEventListener('click', handleClick);
    }
  
    return () => {
      if (submitButton) {
        submitButton.removeEventListener('click', handleClick);
      }
    };
  }, [onLoginClickHandler]);

  const renderLoginModule = () => { 
      return <div className='login_register_page'>
        <LoginRegisterSidebar />
        <LoginRegisterTab tab='login' />
      </div> 
  }

  if (showCompanyDomain(extractedText)) {
    return <CompanyDomain />
  }  
  return (
    (
      renderLoginModule()
    )
  );
  
}

const mapStateToProps = (state) => {
    return {
        language:state.language,
        auth:state.auth
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        //date_format
        setDateFormate:(formate) => { dispatch({type:ActionTypes.SET_DATE_FORMATE , payload:formate}) },
        login:(user) => { dispatch({type:ActionTypes.SET_LOGIN , payload:user}) },
        setUser:(user) => { dispatch({type:ActionTypes.SET_USER , payload:user}) },
    }
}
export default connect(mapStateToProps, mapDispatchToProps) (Login);
